import * as React from "react";
import Svg, { Path } from "react-native-svg";

function OrderCancelled(props) {
  return (
    <Svg width={200} height={126} viewBox="0 0 200 126" fill="none" {...props}>
      <Path
        d="M153.935 95.106c8.227-20.567 5.738-43.532-4.872-61.17L37.998 49.313l106.436-22.182C99.575-28.807 12.265 8.297 20.682 78.923l133.253 16.183z"
        fill="#E6E6E6"
      />
      <Path d="M158.833 72.371H17.334v44.062h141.499V72.371z" fill="#E40046" />
      <Path
        d="M56.797 66.998c1.27.986 1.734 1.304 2.004 1.264 13.1 3.814 1.616 8.284-4.748.696l2.744-1.96zM13.573 107.298v8.956l6.448-.358-1.79-9.314-4.658.716zM49.395 107.298v8.956l-6.448-.358 1.791-9.314 4.657.716z"
        fill="#FFB8B8"
      />
      <Path
        d="M29.693 61.087l9.672-.358C61.678 84.12 53.24 78.785 52.62 110.88l-11.822-3.582 2.508-22.21c.001 0 .661-.44.113-.451-3.432 1.18-5.937-13.424-13.367-11.728-8.456-.405-9.833 12.139-13.255 12.18l2.508 22.209-11.822 3.582C6.16 75.61-.327 83.578 20.738 60.729l8.955.358zM15.364 113.388s-1.433-2.866-3.224-1.433c-1.79 1.433-6.09 5.732-6.09 5.732s-10.388 4.657-3.94 7.522c6.448 2.866 11.821-3.94 11.821-3.94 6.142-1.281 9.685-2.101 6.428-8.8-1.85.8-4.467 1.727-4.995.919zM47.604 113.388s1.433-2.866 3.224-1.433c1.791 1.433 6.09 5.732 6.09 5.732s10.389 4.657 3.94 7.522c-6.447 2.866-11.82-3.94-11.82-3.94-6.143-1.281-9.685-2.101-6.428-8.8 1.85.8 4.466 1.727 4.994.919z"
        fill="#2F2E41"
      />
      <Path
        d="M39.365 20.608c-.533 8.918-12.703 8.133-12.896 0 .533-8.918 12.704-8.133 12.896 0z"
        fill="#FFB8B8"
      />
      <Path
        d="M30.052 25.265c3.133 9.471-4.265 4.315 6.09 11.821l3.94-7.88s-2.866-1.075-2.508-5.016l-7.522 1.075z"
        fill="#FFB8B8"
      />
      <Path
        d="M49.395 30.638l-10.678-2.437c.3 6.439-6.571 5.143-7.77 1.904l-10.21 5.906c4.286 15.96 3.2 16.619-2.507 26.867-2.178 1.99 1.08 3.129 3.915 2.04 2.162-1.334 3.26-2.52 5.578-2.218 10.95 2.28 20.066 2.818 21.509 1.927.516-.739-.015-33.86.163-33.989z"
        fill="#FFB800"
      />
      <Path
        d="M46.53 31.355c.358 0 2.203-.868 2.203-.868 5.369-.09 8.971 36.022 9.26 37.048l-3.582 2.508-5.732-14.687-2.15-24.001z"
        fill="#FFB800"
      />
      <Path
        d="M21.454 73.267c.183 1.352.495 16.534 5.934 9.442.713-5.174-1.713-6.719-2.352-10.159l-3.582.717z"
        fill="#FFB8B8"
      />
      <Path
        d="M22.887 36.012l-1.098-.609c-2.942-.097-2.015 7.693-3.26 13.397-1.017 6.646-.727 13.973.466 23.77.104 3.595 6.543 1.33 7.474 1.055 0 0-2.15-14.687-1.075-17.195 1.075-2.507-2.507-20.418-2.507-20.418z"
        fill="#FFB800"
      />
      <Path
        d="M39.083 14.357a7.685 7.685 0 00-4.371-3.342l-1.337 1.07.52-1.248a7.079 7.079 0 00-1.321-.076l-1.203 1.546.498-1.493c-5.16.554-8.214 6.478-5.535 10.624.413-1.27.915-2.462 1.328-3.732.325.044.654.046.98.005l.502-1.173.14 1.123c1.56-.136 3.87-.434 5.348-.707l-.144-.862.86.717c.453-.105.721-.2.7-.271 1.098 1.771 2.186 2.902 3.285 4.674.417-2.499 1.154-4.576-.25-6.855z"
        fill="#2F2E41"
      />
      <Path d="M150.364 77.686h-31.25V92.51h31.25V77.686z" fill="#fff" />
      <Path
        d="M144.454 80.791h-19.43v1.778h19.43V80.79zM144.454 84.21h-19.43v1.777h19.43V84.21zM144.454 87.628h-19.43v1.777h19.43v-1.777z"
        fill="#E6E6E6"
      />
      <Path
        d="M91.9 81.207l-1.016-1.76-1.016-1.76-1.017 1.76-1.016 1.76h1.092v5.099h1.881v-5.099h1.093z"
        fill="#fff"
      />
      <Path
        d="M160.777 117.484a8.37 8.37 0 008.37-8.37 8.37 8.37 0 10-8.37 8.37z"
        fill="#3F3D56"
      />
      <Path
        d="M162.299 112.823a3.71 3.71 0 10.002-7.418 3.71 3.71 0 00-.002 7.418z"
        fill="#E6E6E6"
      />
      <Path
        d="M155.499 114.963l18.261 7.609-.57 1.808-10.51-1.189-17.786-7.895 9.891 1.142.714-1.475z"
        fill="#3F3D56"
      />
      <Path
        d="M171.641 122.229l22.712-74.503 5.531-9.823.019-.094c.018-.087.424-2.14-.575-3.627a3.249 3.249 0 00-2.199-1.385c-3.053-.573-9.882-.855-10.171-.866l-.054-.003-.054.008c-.187.025-4.551.663-5.538 4.474l-4.748 8.642-.019.062-21.495 70.668 1.183.36 21.476-70.607 4.765-8.671.019-.08c.698-2.868 4.033-3.539 4.476-3.615.698.03 7.117.315 9.932.843a2.04 2.04 0 011.398.856c.616.911.462 2.253.408 2.606l-5.497 9.762-.02.065-22.732 74.568 1.183.36z"
        fill="#3F3D56"
      />
      <Path
        d="M174.962 52.197l-.22 1.217 16.403 2.962.22-1.216-16.403-2.963zM171.898 62.316l-.247 1.212 16.286 3.324.248-1.212-16.287-3.324zM166.443 80.414l-.34 1.188 15.901 4.55.34-1.189-15.901-4.55zM177.197 115.491l.45-1.151-15.433-6.043-.758-8.206 14.405 5.38 4.667 6.752 1.017-.702-4.888-7.073-16.613-6.205 1.009 10.927 16.144 6.321z"
        fill="#3F3D56"
      />
      <Path
        d="M182.558 125.473a8.37 8.37 0 100-16.74 8.37 8.37 0 000 16.74z"
        fill="#3F3D56"
      />
      <Path
        d="M184.746 121.193a3.709 3.709 0 100-7.418 3.709 3.709 0 000 7.418z"
        fill="#E6E6E6"
      />
      <Path
        d="M158.291 8.487l-.778-.778a2.42 2.42 0 00-3.422 0L139 22.799 123.909 7.71a2.42 2.42 0 00-3.422 0l-.778.778a2.423 2.423 0 00-.525 2.637c.122.293.3.56.525.785L134.8 27l-15.091 15.091a2.422 2.422 0 00-.525 2.637c.122.294.3.56.525.785l.778.778a2.42 2.42 0 003.422 0L139 31.201l15.091 15.09a2.42 2.42 0 003.422 0l.778-.778a2.42 2.42 0 000-3.422L143.2 27l15.091-15.091a2.42 2.42 0 000-3.422z"
        fill="#E40046"
      />
      <Path
        opacity={0.1}
        d="M119.17 42.912l14.643-14.643-.141-.141-13.963 13.963a2.419 2.419 0 00-.539.82zM119.5 8.977a2.42 2.42 0 013.422 0l15.091 15.091 15.091-15.09a2.421 2.421 0 013.423 0l.778.777a2.427 2.427 0 01.538 2.602l.448-.448a2.422 2.422 0 00.525-2.637c-.122-.294-.3-.56-.525-.785l-.778-.778a2.42 2.42 0 00-3.422 0L139 22.799 123.909 7.71a2.42 2.42 0 00-3.422 0l-.778.778a2.42 2.42 0 00-.539.82l.33-.33zM143.341 27.141l-1.128 1.128 15.091 15.09a2.422 2.422 0 01.539 2.602l.448-.448a2.423 2.423 0 00.525-2.637c-.122-.293-.3-.56-.525-.785l-14.95-14.95z"
        fill="#000"
      />
    </Svg>
  );
}

export default OrderCancelled;
